import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import CustomerStatementMain from '../../components/AR/customerStatementMain';
import { fetchCustomerStatementList} from '../../actions/arap_actions';
import { setValue } from '../../actions/sales_actions';
import { selectCustomer, resetCurrentCustomer } from '../../actions/customers_actions';

let customerStatementMain = reduxForm({
  form: 'customerStatementMain',
})(CustomerStatementMain);

const selector = formValueSelector('customerStatementMain');

function mapStateToProps(state) {
    const typeRadios = selector(state, 'typeRadios');
    const Days = selector(state, 'Days');
    return {
        typeRadios,
        Days,
        customerStatementListIsLoading: state.arap.customerStatementListIsLoading,
        customerStatementList: state.arap.customerStatementList,
        customerStatementListError: state.arap.customerStatementListError,
        currentCustomer: state.customers.currentCustomer,

    };
}

export default connect(mapStateToProps, { setDefaultOfForm, fetchCustomerStatementList, setValue, selectCustomer, resetCurrentCustomer})(customerStatementMain);



// WEBPACK FOOTER //
// ./master/jsx/containers/AR/customerStatementMain.jsx